import Vue from 'vue'
import Glide from '@glidejs/glide'
Vue.prototype.$eventHub = new Vue();

const accordionMenu = {
    name: 'accordionMenu',
    props: {
      windowWidth: {
        type: Number,
        default:''
      },
      open: {
          type: Boolean,
          default: false,
      }
    },
    data() {
      return {
        hover: false,
        innerOpen: this.open,
      };
    },   
    methods: {      
      toggleSubMenu() {
        this.innerOpen = !this.innerOpen;
      },
      onMouseOver(){
        if(this.windowWidth < 1280) {
          return
        }
        this.innerOpen = true
      },
      onMouseLeave(){
        if(this.windowWidth < 1280) {
          return
        }
        this.innerOpen = false
      },
      startTransition(el) {
        el.style.height = el.scrollHeight + "px";
      },  
      endTransition(el) {
        el.style.height = "";
      },
    },
    watch: {
      open(value) {
        this.innerOpen = value;
      }      
    },
}
const burgerButton = {
  name: 'burgerButton',
  inheritAttrs: false,
  props:['containCoverImage','scrollPosition', 'open' ],
  data() {
    return {
      isOpen: {...this.open}      
    }
  },
  computed: {
    classTextBurger() {
      return this.scrollPosition < 80 && this.containCoverImage || this.isOpen ? 'text-white' : 'text-orange-400'
      
    },
    classBgBurger() {
      return this.scrollPosition < 80 && this.containCoverImage || this.isOpen ? 'bg-white' : 'bg-orange-400'
    },

  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen      
      this.$emit('input', this.isOpen);
    },
    setIsOpen() {
      this.isOpen = this.open
    }   
  },
  watch : {    
    open: {
      handler: 'setIsOpen',
      immediate: true
    },
  },
}

if (document.getElementById('vue-header')) {
  new Vue({
    delimiters: ["[[", "]]"],
    el: '#vue-header',
    components: {
      burgerButton,
      accordionMenu
    },
    data() {
      return {
        isOpen : false,
        isMenuOpen: false,
        windowWidth: window.innerWidth,
        scrollPosition:0,
        containCoverImage: false
      }
    },
    mounted() {
      if (document.querySelector('[data-cover="hero-image"]') ) {        
        this.containCoverImage = true
      } else {
        this.containCoverImage = false
      }

      window.addEventListener("scroll", this.setScroll)      
      window.addEventListener('resize', (e) => {
        this.windowWidth = window.innerWidth;
      });
    },
    destroy() {
      window.removeEventListenr('scroll', this.setScroll)
    },
    watch : {
      scrollPosition: {
        handler: 'setScroll',
        immediate: true
      },
      windowWidth: {
        handler: 'setIsOpen',
        immediate: true
      },
    },
    computed: {           
      classScrollHeader() {
        return {
          'bg-white shadow-header scrolled' : this.scrollPosition > 80  || !this.containCoverImage,
          'text-white' : this.scrollPosition < 80 && this.containCoverImage,
          'is-open': this.isMenuOpen
        }
      },
      logoScroll: function () {
        return this.scrollPosition < 80 && this.containCoverImage ? 'wimoov-white' : 'wimoov'
      }
    },
    methods: {
      setScroll() {
        this.scrollPosition = window.scrollY;
      },
      setIsOpen() {
        if(this.windowWidth > 1280) {
          this.isMenuOpen = false
        }
      }        
    }
  })
}